export default "__VITE_ASSET__gd5CL$ui__$_?nuxt_component=async&nuxt_component_name=SvgoWoman&nuxt_component_export=default__"